import React, { Component } from "react";
import Button from "../Button";
import apiInstance from "../apiInstance";

class DeavadminTools extends Component {
constructor(props) {
    super(props);
    this.state = {
        logs: [],
        logsOpen: true
    };
}

handleSubmit = (action) => {
    switch (action) { 
        case "userUpdate":
            this.setState((prevState) => {
                return {
                    ...prevState,
                    logs: [...prevState.logs, {msg: "Updating users...", error: false}],
                };
            });

            apiInstance.put('/devadmin/tool/update-user')
            .then((response) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        logs: [...prevState.logs, {msg: `Updated user role for ${response.data.count} users`, error: false}],
                    };
                })
            })
            .catch((error) => {
                if (error.response) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            logs: [ ...prevState.logs, {msg: error.response.data.error, error: true}],
                        };
                    });
                }
            })

            break;
        case "paymentUpdate":
            this.setState((prevState) => {
                return {
                    ...prevState,
                    logs: [...prevState.logs, { msg: "Updating payments...", error: false }],
                };
            });

            apiInstance.put('/devadmin/tool/update-payment')
            .then((response) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        logs: [...prevState.logs, 
                            {
                                msg: `Updated payment method for ${response.data.paymentMethodCount} payments`, 
                                error: false
                            }, 
                            {
                                msg: `Updated user ID for ${response.data.userIDCount} payments`, 
                                error: false
                            },
                            {
                                msg: `Updated user name for ${response.data.userNameCount} payments`, 
                                error: false
                            },
                            {
                                msg: `Updated widget name for ${response.data.widgetNameCount} payments`, 
                                error: false
                            }
                        ],
                    };
                })
            })
            .catch((error) => {
                if (error.response) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            logs: [...prevState.logs, {msg: error.response.data.error, error: true}],
                        };
                    });
                }
            })

            break;
        case "widgetUpdate":
            this.setState((prevState) => {
                return {
                    ...prevState,
                    logs: [...prevState.logs, { msg: "Updating widgets...", error: false }],
                };
            });

            apiInstance.put('/devadmin/tool/update-widget')
            .then((response) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        logs: [...prevState.logs, 
                            {
                                msg: `Updated status for ${response.data.statusUpdatedCount} widgets`, 
                                error: false
                            },
                            {
                                msg: `Updated created date for ${response.data.dateUpdatedCount} widgets`, 
                                error: false
                            },
                            {
                                msg: `Updated default payment method for ${response.data.defaultMethodCount} widgets`, 
                                error: false
                            }
                        ],
                    };
                })
            })
            .catch((error) => {
                if (error.response) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            logs: [...prevState.logs, {msg: error.response.data.error, error: true}],
                        };
                    });
                }
            })

            break;
        case "addRenewalPayment":
            this.setState((prevState) => {
                return {
                    ...prevState,
                    logs: [...prevState.logs, { msg: "Adding previous renewal payments...", error: false }],
                };
            });

            apiInstance.put('/devadmin/tool/add-renewal-payments')
            .then((response) => {
                this.setState((prevState) => {
                    return {
                        ...prevState,
                        logs: [...prevState.logs, {msg: `Added ${response.data.count} payments`, error: false}],
                    };
                })
            })
            .catch((error) => {
                if (error.response) {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            logs: [...prevState.logs, {msg: error.response.data.error, error: true}],
                        };
                    });
                }
            })

            break;
            
        default:
            break;
    }
}

handleLogClick = () => {
    this.setState((prevState) => {
        return {
            ...prevState,
            logsOpen: !prevState.logsOpen
        }
    })
}

handleClearLogs = () => {
    this.setState((prevState) => {
        return {
            ...prevState,
            logs: []
        }
    })
}

render() {
    const { logs, logsOpen } = this.state;
    return (
    <div className="mjwidev-main mjwidev-tools-section">
        <h2>Devadmin Tools</h2>
        
        <div className="mjwidev-tools-btns">
            <Button eventHandler={() => this.handleSubmit("userUpdate")} name="Update Users" />
            <Button eventHandler={() => this.handleSubmit("paymentUpdate")} name="Update Payments" />
            <Button eventHandler={() => this.handleSubmit("widgetUpdate")} name="Update Widgets" />
            <Button eventHandler={() => this.handleSubmit("addRenewalPayment")} name="Import Payments" />
        </div>

        <div className="mjwidev-log-header">
            <span>Logs</span>
            <div className="mjwidev-log-btn">
            <i class="fa-solid fa-trash" onClick={this.handleClearLogs}></i>
            {logsOpen ? <i class="fa-solid fa-caret-up" onClick={this.handleLogClick}></i> : <i class="fa-solid fa-caret-down" onClick={this.handleLogClick}></i>}
            </div>
        </div>

        <div className={"mjwidev-log-wrapper" + (logsOpen ? '' : ' mjwi-hidden')}>
            { logs && logs.map((item, index) => (
                <p key={index} className={item.error ? 'mjwi-error' : 'mjwi-msg'}>{item.msg}</p>
            ))}
        </div>


    </div>
    );
}
}
export default DeavadminTools;